import { useTranslation } from "react-i18next";

const TERMS_URL = "https://elevenbase.pro/terms.html";
const PRIVACY_URL = "https://elevenbase.pro/privacy.html";
const COOKIE_URL = "https://elevenbase.pro/cookie.html";

type Variant = "app" | "auth";

export function AppFooter({ variant = "app" }: { variant?: Variant }) {
  const { t } = useTranslation("shell");
  const isAuth = variant === "auth";
  return (
    <footer
      className={
        isAuth
          ? "w-full mt-8 border-t border-border/60 bg-background/40 px-4 py-6 text-xs text-muted-foreground"
          : "w-full border-t border-border/60 bg-background/40 px-4 sm:px-6 py-6 text-xs text-muted-foreground"
      }
    >
      <div className="max-w-[1600px] mx-auto flex flex-col gap-3">
        <p className="leading-relaxed">
          {t("footer.copyright")}{" "}
          <a
            href="https://www.linkedin.com/in/andreacamolese/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline-offset-2 hover:underline hover:text-foreground"
          >
            {t("footer.developerName")}
          </a>
          {t("footer.disclaimer")}
        </p>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="hover:text-foreground hover:underline">
            {t("footer.links.terms")}
          </a>
          <span aria-hidden className="opacity-40">|</span>
          <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="hover:text-foreground hover:underline">
            {t("footer.links.privacy")}
          </a>
          <span aria-hidden className="opacity-40">|</span>
          <a href={COOKIE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-foreground hover:underline">
            {t("footer.links.cookie")}
          </a>
          <span aria-hidden className="opacity-40">|</span>
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              // Cookiebot (caricato via GTM) e' il CMP attivo. Funding Choices/AdSense
              // sono stati rimossi (2026-06). renew() riapre il banner di consenso.
              const w = window as unknown as {
                Cookiebot?: { renew?: () => void };
              };
              w.Cookiebot?.renew?.();
            }}
            className="hover:text-foreground hover:underline"
          >
            {t("footer.links.consent")}
          </a>
        </div>
      </div>
    </footer>
  );
}
